import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Grid, Typography, styled } from '@mui/material';
import RealestateMenu from '../realestateMenu/RealestateMenu';
import NavMenu from '../navmenue/NavMenu';
import { useStore } from '../../store/context';
import useMedia from '../../hooks/useMedia';
import LoadingSpinner from '../spinner/LoadingSpinner';

const GreetingHeader = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyItens: 'center',
  minHeight: '90px',
  paddingTop: '10px',
});

interface Props {
  children?: React.ReactNode;
  subheader?: React.ReactNode;
  showHeader?: boolean;
}

const GridContainer: FC<Props> = observer(props => {
  const { children, subheader, showHeader } = props;
  const { welcomeStore } = useStore();
  const { currentEstate } = welcomeStore;
  const isMobile = useMedia('md');

  const welcomeData = welcomeStore.getWelcomeData();
  const user = welcomeData?.userData;

  return (
    <Grid container>
      <Grid
        id="navmenu"
        item
        sm={0}
        xs={0}
        md={3}
        lg={3}
        xl={2}
        paddingTop={15}
        height="100vh"
      >
        <NavMenu />
      </Grid>
      <Grid item sm={12} xs={12} md={9} lg={9} xl={10}>
        {!showHeader && (
          <Grid id="greeting" item xs={12}>
            <GreetingHeader sx={{ paddingBottom: isMobile ? 0 : '20px' }}>
              <Typography textAlign="center" variant="h4" color="secondary">
                Hallo
              </Typography>
              {currentEstate ? (
                <Box>
                  <Typography textAlign="center" variant="h4" color="secondary">
                    {`${user?.firstname || ''} ${user?.lastname || ''}`}
                    {user?.firstname2 && ` und`}
                  </Typography>
                  <Typography textAlign="center" variant="h4" color="secondary">
                    {`${user?.firstname2 || ''} ${user?.lastname2 || ''}`}
                  </Typography>
                  <RealestateMenu />
                  {subheader}
                </Box>
              ) : (
                <LoadingSpinner />
              )}
            </GreetingHeader>
          </Grid>
        )}
        {children}
      </Grid>
    </Grid>
  );
});

export default GridContainer;
